import { InvitationActions } from "./InvitationActions";

import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { WorkspaceInvite } from "@/types/workspace-invite";

export const InviteList = ({
  invites,
  isOpen,
  setIsOpen,
}: {
  invites: WorkspaceInvite[];
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}) => {
  if (invites.length === 0) {
    return null;
  }

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="max-h-[85vh] max-w-2xl overflow-y-auto">
        <DialogHeader className="space-y-3 text-center">
          <DialogTitle>You're invited to join workspaces</DialogTitle>
        </DialogHeader>

        <InvitationActions invites={invites} />
      </DialogContent>
    </Dialog>
  );
};
